import React, { useState, useCallback, useEffect } from "react";
import { Box, TextField, Typography, IconButton } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const IxcBuscarFaturaNode = React.memo(({ data, id }) => {
  const [idClienteVariable, setIdClienteVariable] = useState(
    data?.idClienteVariable || "ixc_cliente_id"
  );
  const storageItems = useNodeStorage();

  const updateNodeData = useCallback(() => {
    data.idClienteVariable = idClienteVariable;
  }, [idClienteVariable, data]);

  useEffect(() => {
    updateNodeData();
  }, [idClienteVariable, updateNodeData]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 2,
        width: 280,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        border: "2px solid #00695c",
      }}
    >
      <Handle
        type="target"
        position="left"
        id="ixcBuscarFatura-in"
        style={{
          left: -8,
          top: "50%",
          transform: "translateY(-50%)",
          background: "#00695c",
          width: 12,
          height: 12,
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ReceiptLongIcon fontSize="small" sx={{ color: "#00695c" }} />
          <Typography variant="subtitle2" fontWeight="bold" sx={{ color: "#00695c" }}>
            IXC: Buscar Fatura
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <IconButton
            size="small"
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <TextField
        label="Variável com ID do Cliente"
        variant="outlined"
        size="small"
        value={idClienteVariable}
        onChange={(e) => setIdClienteVariable(e.target.value)}
        fullWidth
        placeholder="ixc_cliente_id"
        helperText="Variável obtida do nó 'Buscar Cliente'"
      />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1 }}>
        <Typography variant="caption" color="textSecondary">
          Saída: ixc_fatura_valor, ixc_fatura_datavenc, ixc_fatura_linha,
          ixc_pix_qrcode, ixc_pix_disponivel
        </Typography>
      </Box>

      <Handle
        type="source"
        position="right"
        id="success"
        style={{
          right: -8,
          top: "35%",
          background: "#4caf50",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "32%", color: "#4caf50", fontSize: "0.65rem" }}
      >
        Com fatura
      </Typography>

      <Handle
        type="source"
        position="right"
        id="sem_faturas"
        style={{
          right: -8,
          top: "55%",
          background: "#ff9800",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "52%", color: "#ff9800", fontSize: "0.65rem" }}
      >
        Sem faturas
      </Typography>

      <Handle
        type="source"
        position="right"
        id="error"
        style={{
          right: -8,
          top: "75%",
          background: "#f44336",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "72%", color: "#f44336", fontSize: "0.65rem" }}
      >
        Erro
      </Typography>
    </Box>
  );
});

export default IxcBuscarFaturaNode;
